import React from "react";
import { getClassName } from "@sscs/utils";
import { NLinesShowMore } from "../index";
import { Title as SectionTitle } from "../Section/Section";
import styles from "./keyValueList.module.scss";
/**
 * Key-value data in two aligned columns, with the `list` array's string entries as section headings.
 * Each block is its own `<dl>` inheriting the root's columns via `subgrid`, so every block shares ONE
 * key column — alignment is structural. Headings are real `Section.Title`s in the grid parent (a
 * heading may not be a `<dl>` child). Zebra striping restarts under every heading, so each block reads
 * as its own table.
 */
const KeyValueList = ({ list, headingAs = "h3", hideKeys = false, className, }) => {
    const items = Array.isArray(list) ? list : [list];
    return (React.createElement("div", { "data-testid": "description-list", className: getClassName(styles["key-value-list"], { [styles["hide-keys"]]: hideKeys }, className) }, items.map((item, index) => {
        if (typeof item === "object") {
            const transformedItem = Array.isArray(item) ? item : Object.entries(item);
            return (React.createElement("dl", { key: index, className: styles.block }, transformedItem.map(([key, value], index) => (React.createElement(React.Fragment, { key: index },
                React.createElement("dt", { className: `${styles.row} ${styles["key-column"]}` }, key),
                React.createElement("dd", { className: `${styles.row} ${styles["value-column"]}` },
                    React.createElement(NLinesShowMore, { value: value, numberOfLines: 3 })))))));
        }
        else {
            return (React.createElement(SectionTitle, { key: index, as: headingAs, className: styles.heading }, item));
        }
    })));
};
export default KeyValueList;
//# sourceMappingURL=KeyValueList.js.map